import {Button, Stack, Text, createStyles} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

export type ModelHubSearchEntity = 'batches' | 'models' | 'predictions';

const ENTITY_LABELS: Record<ModelHubSearchEntity, string> = {
  batches: 'batches',
  models: 'models',
  predictions: 'predictions',
};

interface ModelHubNoSearchResultsProps {
  entity: ModelHubSearchEntity;
  onClearSearch: () => void;
}

/**
 * Centered empty state shown when Model Hub listing filters return no results.
 */
export default function ModelHubNoSearchResults({
  entity,
  onClearSearch,
}: ModelHubNoSearchResultsProps): JSX.Element {
  const {classes} = useStyles();
  const label = ENTITY_LABELS[entity];

  return (
    <div className={classes.root}>
      <BenchlingIcon className={classes.icon} icon="search" />
      <Stack align="center" spacing="xs">
        <Text fw={600} size="md">
          No {label} match your filters
        </Text>
        <Text color="dimmed" size="sm">
          Adjust or clear your filters to see all {label}
        </Text>
      </Stack>
      <Button onClick={onClearSearch} size="sm" variant="ghost">
        Clear filters
      </Button>
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: theme.spacing.xs,
    margin: '0 auto',
    maxWidth: 460,
    padding: `calc(${theme.spacing.xl} * 2) 0`,
    textAlign: 'center' as const,
  },
  icon: {
    color: theme.colors.gray[4],
    display: 'block',
    fontSize: 24,
    marginBottom: theme.spacing.xs,
  },
}));
